import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import iconLogo from '../../assets/images/TestigoFavicon.png';
import testiGoLogo from '../../assets/images/TestigoLogo.png'

import Usericon from '../../assets/images/icons/user.svg';
import UsericonHover from '../../assets/images/icons/userfff.svg';
import doctoricon from '../../assets/images/icons/doctor.svg';
import doctoriconHover from '../../assets/images/icons/doctorfff.svg';
import centericon from '../../assets/images/icons/center.svg';
import centericonHover from '../../assets/images/icons/centerfff.svg';
import operatoricon from '../../assets/images/icons/operator-icon.svg';
import operatorIconHover from '../../assets/images/icons/operator-iconfff.svg';
import cms from '../../assets/images/icons/cms.svg';
import cmsHover from '../../assets/images/icons/cmsfff.svg';
import xrayMachinicon from '../../assets/images/icons/xray-machin-icon.svg';
import xrayMachiniconHover from '../../assets/images/icons/xray-machin-iconfff.svg';
import xrayTypeicon from '../../assets/images/icons/xray-type-icon.svg';
import xrayTypeiconHover from '../../assets/images/icons/xray-type-iconfff.svg';




const SideBar = ({ menuIconOnClick, handleMouseOver, handleMouseOut }) => {
    const [isActive, setIsActive] = useState('');
    const [cmsMenuActive, setCmsMenuActive] = useState(false)
    const onClick = (value) => {
        setIsActive(value)
    };
    // const onClickSubMenu = (value) => {
    //     setIsActive(value)

    // };
    const onCLickCms = () => {
        setCmsMenuActive((prevState) => prevState ? false : true)
    }
    useEffect(() => {
        setIsActive(window.location.pathname)

        const addClassBody = document.body.classList.add('dashboard-BG')
        console.log(addClassBody);
    })


    return (
        <>
            <div className="sidebar-wrapper admin-sidebar" data-simplebar="true"
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
            >
                <div className="sidebar-header">
                    <div className="">
                        <img src={iconLogo} className="logo-icon-2" alt="" />
                    </div>
                    <div>
                        <h4 className="logo-text"><img src={testiGoLogo} className="side_logo" alt="" /></h4>
                    </div>
                    <a href="#" className="toggle-btn ms-auto">
                        {" "}
                        <i className="bx bx-menu" onClick={menuIconOnClick} />
                    </a>
                </div>

                <ul className="metismenu" id="menu">

                    <li className={isActive === '/dashboard' ? 'mm-active' : ''}>
                        <Link to='/dashboard' onClick={onClick}>
                            <div className="parent-icon">
                                <img src={centericon} />
                                <img src={centericonHover} />
                            </div>
                            <div className="menu-title">Dashboard</div>
                        </Link>
                    </li>
                    <li className={isActive === '/center' ? 'mm-active' : ''}>
                        <Link to='/center' onClick={onClick}>
                            <div className="parent-icon">
                                <img src={centericon} />
                                <img src={centericonHover} />
                            </div>
                            <div className="menu-title">Center</div>
                        </Link>
                    </li>
                    <li className={isActive === '/operator' ? 'mm-active' : ''}>
                        <Link to='/operator' onClick={onClick}>
                            <div className="parent-icon">
                                <img src={operatoricon} />
                                <img src={operatorIconHover} />
                            </div>
                            <div className="menu-title">Operator</div>
                        </Link>
                    </li>
                    <li className={isActive === '/users' ? 'mm-active' : ''}>
                        <Link to='/users' onClick={onClick}>
                            <div className="parent-icon">
                                <img src={Usericon} />
                                <img src={UsericonHover} />
                            </div>
                            <div className="menu-title">User</div>
                        </Link>
                    </li>
                    <li className={isActive === '/doctor' ? 'mm-active' : ''}>
                        <Link to='/doctor' onClick={onClick}>
                            <div className="parent-icon">
                                <img src={doctoricon} />
                                <img src={doctoriconHover} />
                            </div>
                            <div className="menu-title">Radiologist</div>
                        </Link>
                    </li>
                    <li className={isActive === '/xray' ? 'mm-active' : ''}>
                        <Link to='/xray' onClick={onClick}>
                            <div className="parent-icon">
                                <img src={xrayTypeicon} />
                                <img src={xrayTypeiconHover} />
                            </div>
                            <div className="menu-title">X-ray Types</div>
                        </Link>
                    </li>

                    <li className={isActive === '/xray-booking' ? 'mm-active' : ''}>
                        <Link to='/xray-booking' onClick={onClick}>
                            <div className="parent-icon">
                                <img src={xrayTypeicon} />
                                <img src={xrayTypeiconHover} />
                            </div>
                            <div className="menu-title">X-ray Bookings</div>
                        </Link>
                    </li>
                    <li className={isActive === '/xray-investigation-report' ? 'mm-active' : ''}>
                        <Link to='/xray-investigation-report' onClick={onClick}>
                            <div className="parent-icon">
                                <img src={xrayTypeicon} />
                                <img src={xrayTypeiconHover} />
                            </div>
                            <div className="menu-title">X-ray investigation</div>
                        </Link>
                    </li>

                    <li className={isActive === '/transactions' ? 'mm-active' : ''}>
                        <Link to='/transactions' onClick={onClick}>
                            <div className="parent-icon">
                                <img src={xrayTypeicon} />
                                <img src={xrayTypeiconHover} />
                            </div>
                            <div className="menu-title">Transactions</div>
                        </Link>
                    </li>


                    {/*
                    <li className={isActive === '/xray-machine' ? 'mm-active' : ''}>
                        <Link to='/xray-machine' onClick={onClick}>
                            <div className="parent-icon">
                                <img src={xrayMachinicon} />
                                <img src={xrayMachiniconHover} />
                            </div>
                            <div className="menu-title">X-ray Machine</div>
                        </Link>
                    </li> */}

                    <li className="menu-label">Settings</li>
                    <li className={isActive === '/configuration' ? 'mm-active' : ''}>
                        <Link to='/configuration' onClick={onClick}>
                            <div className="parent-icon">
                                <img src={cms} />
                                <img src={cmsHover} />
                            </div>
                            <div className="menu-title">Configuration</div>
                        </Link>
                    </li>

                    <li className="menu-label">CMS</li>
                    <li className={`${cmsMenuActive === true ? 'mm-active' : ''} `}>
                        <a className="has-arrow" href="#" onClick={onCLickCms}>
                            <div className="parent-icon icon-color-11">
                                <img src={cms} />
                                <img src={cmsHover} />
                            </div>
                            <div className="menu-title">CMS</div>
                        </a>
                        <ul className={`mm-collapse ${cmsMenuActive === true ? 'mm-show' : ''} `}>
                            <li className={isActive === '/manage-pages' ? 'mm-active' : ''}>
                                {" "}
                                <Link to='/manage-pages' onClick={onClick}>
                                    <i className="bx bx-right-arrow-alt" />
                                    Manage Menu
                                </Link>
                            </li>
                            <li className={isActive === '/manage-pages-content' ? 'mm-active' : ''}>
                                {" "}
                                <Link to='/manage-pages-content' onClick={onClick}>
                                    <i className="bx bx-right-arrow-alt" />
                                    Manage Page Content
                                </Link>
                            </li>
                            <li className={isActive === '/slider' ? 'mm-active' : ''}>
                                {" "}
                                <Link to='/slider' onClick={onClick}>
                                    <i className="bx bx-right-arrow-alt" />
                                    Slider
                                </Link>
                            </li>
                            <li className={isActive === '/social-media-links' ? 'mm-active' : ''}>
                                {" "}
                                <Link to='/social-media-links' onClick={onClick}>
                                    <i className="bx bx-right-arrow-alt" />
                                    Social Media links
                                </Link>
                            </li>

                            <li className={isActive === '/gallery' ? 'mm-active' : ''}>
                                {" "}
                                <Link to='/gallery' onClick={onClick}>
                                    <i className="bx bx-right-arrow-alt" />
                                    Gallery
                                </Link>
                            </li>
                            <li className={isActive === '/contact-us' ? 'mm-active' : ''}>
                                {" "}
                                <Link to='/contact-us' onClick={onClick}>
                                    <i className="bx bx-right-arrow-alt" />
                                    Contact Us
                                </Link>
                            </li>
                            <li className={isActive === '/our-team' ? 'mm-active' : ''}>
                                {" "}
                                <Link to='/our-team' onClick={onClick}>
                                    <i className="bx bx-right-arrow-alt" />
                                    Our Team
                                </Link>
                            </li>
                            <li className={isActive === '/faq' ? 'mm-active' : ''}>
                                {" "}
                                <Link to='/faq' onClick={onClick}>
                                    <i className="bx bx-right-arrow-alt" />
                                    Faq
                                </Link>
                            </li>
                        </ul>
                    </li>
                    {/* <li className="menu-label">App CMS</li>
                    <li className={`${cmsMenuActive === true ? 'mm-active' : ''} `}>
                        <a className="has-arrow" href="#" onClick={onCLickCms}>
                            <div className="parent-icon icon-color-11">
                                <img src={cms} />
                                <img src={cmsHover} />
                            </div>
                            <div className="menu-title">App CMS</div>
                        </a>
                        <ul className={`mm-collapse ${cmsMenuActive === true ? 'mm-show' : ''} `}>
                            <li className={isActive === '/manage-pages' ? 'mm-active' : ''}>
                                {" "}
                                <Link to='/manage-pages' onClick={onClick}>
                                    <i className="bx bx-right-arrow-alt" />
                                    Manage Menu
                                </Link>
                            </li>
                        </ul>
                    </li>     */}
                </ul>
                {/*end navigation*/}
            </div>
            {/*end sidebar-wrapper*/}
            {/* </div> */}

        </>
    )
}

export default SideBar;
